import { imageStore } from '../images.js';
import Sprite from '../ui/Sprite.js';
import { globalItemDataStore } from '../OverworldAnimation.js';
import {
    healingItemIDs,
    keyItemIds,
    pokeballItemIDs,
    moveItemIDs,
    evVitaminItemIds,
    evReducingBerryItemIds,
} from '../constants.js';

export default class Item {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            id: this.id,
        };
    }

    constructor({
        id,
        description,
        price,
        overworldOptions = ['Use', 'Cancel'],
        battleOptions = ['Use', 'Cancel'],
    }) {
        // this.stateMachine = getOSM();
        this.id = id;
        this.name = globalItemDataStore[id]?.name ?? '';
        this.description = description;
        this.price = price;
        this.overworldOptions = overworldOptions;
        this.battleOptions = battleOptions;
        this.canBeHeld = true;

        this.icon = new Sprite({
            position: {
                x: 0,
                y: 0,
            },
            image: imageStore.get(`img/items/${id}.png`),
            moving: false,
            frames: {
                max: 1,
                val: 0,
            },
            visible: true,
        });
    }

    isRareCandy() {
        return ['rare_candy'].includes(this.id);
    }

    isTM() {
        return [].includes(this.id);
    }

    isHM() {
        return ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'hm6', 'hm7', 'hm8', 'hm9', 'hm10'].includes(this.id);
    }

    isTMorHM() {
        return this.isTM() || this.isHM();
    }

    isHealingItem() {
        return healingItemIDs.includes(this.id);
    }

    isPokeball() {
        return pokeballItemIDs.includes(this.id);
    }

    isMoveItem() {
        return moveItemIDs.includes(this.id);
    }

    isKeyItem() {
        return keyItemIds.includes(this.id);
    }

    isEVItem() {
        return evVitaminItemIds.includes(this.id) || evReducingBerryItemIds.includes(this.id);
    }

    static isRareCandy(id) {
        return id === 'rare_candy';
    }

    static isTMorHM(id) {
        // TODO: Include TMs
        return ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'hm6', 'hm7', 'hm8', 'hm9', 'hm10'].includes(id);
    }

    static isPokeball(id) {
        return pokeballItemIDs.includes(id);
    }

    static isMoveItem(id) {
        return moveItemIDs.includes(id);
    }

    static isKeyItem(id) {
        return keyItemIds.includes(id);
    }
}
